import { useUserCurrencySymbol } from '@/shared/providers/user-provider/use-user';
import { getThemeBrand } from './useBrandTheme';

const { defaultSymbol, guestSymbol } = getThemeBrand().currency;

export const useCurrencySymbol = ({ guest = false } = {}) =>
  useUserCurrencySymbol() || (guest ? guestSymbol : defaultSymbol);
